import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { AuthService } from '../../../core/auth/auth.service';
import {
  PERSON_ROLE_LABELS, TARGET_TYPE_LABELS, caseStatusBadge, initials, severityBadge,
} from '../../../core/critical-case/critical-case.labels';
import { CriticalCaseDetail as CaseDetail } from '../../../core/critical-case/critical-case.models';
import { CriticalCaseService } from '../../../core/critical-case/critical-case.service';
import { STATE_LABELS } from '../../../core/occurrence/occurrence.labels';
import { PageHeader } from '../../../shared/page-header/page-header';

@Component({
  selector: 'app-critical-case-detail',
  imports: [RouterLink, DatePipe, PageHeader],
  templateUrl: './critical-case-detail.html',
})
export class CriticalCaseDetail implements OnInit {
  private readonly service = inject(CriticalCaseService);
  private readonly route = inject(ActivatedRoute);
  private readonly destroyRef = inject(DestroyRef);
  protected readonly auth = inject(AuthService);

  protected readonly item = signal<CaseDetail | null>(null);
  protected readonly loading = signal(true);
  protected readonly error = signal<string | null>(null);

  protected readonly roleLabels = PERSON_ROLE_LABELS;
  protected readonly targetLabels = TARGET_TYPE_LABELS;
  protected readonly stateLabels = STATE_LABELS as Record<string, string>;
  protected readonly statusBadge = caseStatusBadge;
  protected readonly severityBadge = severityBadge;
  protected readonly initials = initials;

  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      this.load(Number(params.get('id')));
    });
  }

  protected stateLabel(state: string): string {
    return this.stateLabels[state] ?? state;
  }

  private load(id: number): void {
    this.loading.set(true);
    this.error.set(null);
    this.service.get(id).subscribe({
      next: (detail) => {
        this.item.set(detail);
        this.loading.set(false);
      },
      error: (err: HttpErrorResponse) => {
        const apiMessage = (err.error as { message?: string } | null)?.message;
        this.error.set(err.status === 404
          ? 'Este caso crítico não existe.'
          : apiMessage ?? 'Não foi possível carregar o caso crítico.');
        this.loading.set(false);
      },
    });
  }
}
